export const breakpoints = {
    lsrpSidebar: 1140,
    desktop: 960
};
